/**
 * フッターがビューポートに入ったら追従CTAをフェードアウト、外れたらフェードイン
 */
const floatingCtaFooterFade = () => {
  const cta = document.querySelector(".c-floating-cta");
  if (!cta) return;

  const footer = cta.closest("footer.l-footer");
  if (!footer) return;

  if (!("IntersectionObserver" in window)) return;

  const links = cta.querySelectorAll("a");

  const setHidden = (hidden) => {
    cta.classList.toggle("c-floating-cta--footer-inview", hidden);
    links.forEach((a) => {
      if (hidden) {
        a.setAttribute("tabindex", "-1");
      } else {
        a.removeAttribute("tabindex");
      }
    });
    if (hidden) {
      cta.setAttribute("aria-hidden", "true");
    } else {
      cta.removeAttribute("aria-hidden");
    }
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      setHidden(entry.isIntersecting);
    },
    { threshold: 0, rootMargin: "0px" }
  );

  observer.observe(footer);
};
